import { BlueBirdTheme, Typography } from "@kitbird/core";
import { ReactNode } from "react";

interface LabelAndValueI {
  label: string | ReactNode;
  value: string | ReactNode;
}

const { gray } = BlueBirdTheme.colors;

const LabelAndValue = ({ label, value }: LabelAndValueI) => (<>
  <Typography level={6} color={gray.bodyText}>{label}</Typography>
  <Typography level={6} color={gray.disable}>:</Typography>
  <Typography level={6} color={gray.subtitle} fontWeight="bold">{value}</Typography>
</>);

export default LabelAndValue;
